export enum EnvEnum {
  LOCAL = 'local',
  DEV = 'dev',
  STAGING = 'staging',
  PROD = 'prod',
  // To support new tactical env, with additional envs may need to rework this enum
  PROD2 = 'prod-tactical-env',
}
